import { useEffect, useState } from "react";
import api from "@/lib/api";

export const usePublicContent = (type) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    setLoading(true);
    api.get(`/public/${type}`)
      .then((res) => { if (active) setData(res.data || []); })
      .catch((e) => { if (active) setError(e); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [type]);

  return { data, loading, error };
};
